import { LogLevel } from '@azure/msal-browser'
import type { Configuration, RedirectRequest } from '@azure/msal-browser'

// TODO: Replace the placeholder values below with your actual registered app values.
// Option 1 (External ID tenant subdomain): authority: `https://<tenant-subdomain>.ciamlogin.com/`
// Option 2 (Custom domain): authority: `https://<custom-domain>/<tenant-id>` and add that domain to knownAuthorities.
// You can also override these at runtime using Vite env variables (define in .env as VITE_AZURE_CLIENT_ID, etc.).

// Provided configuration values
//const TENANT_ID = 'c8fc0f8d-ac4f-422a-833a-a9ef70a08239'
//const DEFAULT_CLIENT_ID = 'aa2f4ac9-c44f-4387-8d44-283fd0d008dd'
//const DEFAULT_AUTHORITY = 'https://metsoftcustomers.ciamlogin.com/'

const clientId = (import.meta as any).env.VITE_AZURE_CLIENT_ID?.trim()
const authority = (import.meta as any).env.VITE_AZURE_AUTHORITY?.trim() // ciam subdomain style authority
const knownAuthoritiesEnv = (import.meta as any).env.VITE_AZURE_KNOWN_AUTHORITIES || ''

export const msalConfig: Configuration = {
  auth: {
    clientId, // mandatory
    authority,
    knownAuthorities: knownAuthoritiesEnv
      .split(',')
      .map((s: string) => s.trim())
      .filter((s: string) => !!s),
    redirectUri: '/', // Vite dev server origin (http://localhost:5173/) + slash acts as root
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            break
          case LogLevel.Warning:
            console.warn(message)
            break
          case LogLevel.Info:
            console.info(message)
            break
          case LogLevel.Verbose:
            console.debug(message)
            break
          default:
            break
        }
      },
    },
  },
}

// Scopes to request during initial login (OIDC scopes are automatically added: openid, profile, email)
const scopesEnv = (import.meta as any).env.VITE_API_SCOPES || ''
const initialApiScopes: string[] = Array.from(new Set(
  scopesEnv
    .split(',')
    .map((s: string) => s.trim())
    .filter((s: string) => !!s)
))

export const loginRequest: RedirectRequest = {
  scopes: initialApiScopes,
}

// Helper to detect if placeholder values still present
export function isConfigPlaceholder(): boolean {
  // Warn only if clientId missing/placeholder, or authority missing
  if (!clientId || clientId === 'REPLACE_CLIENT_ID') return true
  if (!authority) return true
  return false
}

// Export tenant id if needed elsewhere (e.g., building API audience values)
//export const tenantId = TENANT_ID
